export default __webpack_public_path__ + "static/ci-cd-intelligente-machine-learning-28ea077187507a0af9182a792dc2e399.jpg";